import React, { Component } from 'react'
import { SubmissionError } from 'redux-form'
import { connect } from 'react-redux'
import classNames from 'classnames'

import {
  createInvite,
  deleteInvite,
  removeUser,
} from '../../../ducks/organizations'

import { INVITE_LIMIT_MESSAGE } from '../../../constants'
import MembersForm from './MembersForm'
import './Team.css'

class MemberItem extends Component {
  render() {
    const { email, name, isInvite, isCurrentUser, onDelete, hasTeamSwitcher } =
      this.props

    return (
      <div
        className={classNames(
          !hasTeamSwitcher && 'team-members-member',
          hasTeamSwitcher && 'settings-list-item',
          isInvite && 'team-members-invite'
        )}
      >
        <div className="team-members-member-details">
          <h4>{isInvite ? email : name}</h4>
          <p>{isInvite ? 'Invited' : email}</p>
        </div>
        <div className="team-members-member-action">
          {isCurrentUser ? (
            'You'
          ) : (
            <div>
              {onDelete ? (
                <div>
                  <a onClick={onDelete} className="deemphasize">
                    {isInvite ? 'Cancel Invitation' : 'Remove'}
                  </a>
                </div>
              ) : null}
            </div>
          )}
        </div>
      </div>
    )
  }
}

class Members extends Component {
  handleAdd = async ({ email }) => {
    const { onInvite, createInvite, organization } = this.props
    const members = organization.Users
    email = email.toLowerCase()

    const sameEmail = members.filter(u => u.email === email)

    if (sameEmail.length > 0) {
      throw new SubmissionError({
        email: `${email} is already part of your team!`,
      })
    }

    try {
      await createInvite({
        email,
        organizationId: organization.id,
      })
    } catch (err) {
      const status = err.response && err.response.status
      const data = err.response && err.response.data
      let message = (data && data.error) || 'An unknown error occurred'

      if (status === 429) {
        message = INVITE_LIMIT_MESSAGE
      }

      throw new SubmissionError({
        email: message,
      })
    }

    onInvite()
  }

  handleRemoveUser = userId => async () => {
    const { organization, removeUser, onReload } = this.props
    const members = organization.Users
    const user = members.filter(u => u.id === userId)[0]
    const { name } = user

    if (!window.confirm(`Are you sure you want to remove ${name}?`)) {
      return
    }

    await removeUser({ userId, organizationId: organization.id })

    // Re-fetch the data
    onReload()
  }

  handleDeleteInvite = inviteId => async () => {
    const { deleteInvite, onReload } = this.props

    if (!window.confirm(`Are you sure you want to remove this invitation?`)) {
      return
    }

    await deleteInvite(inviteId)

    // Re-fetch the data
    onReload()
  }

  userIsAdmin = () => {
    const { organization, currentUserId } = this.props
    const members = organization.Users
    const user = members.filter(u => u.id === currentUserId)[0]

    return user && user.OrganizationUser.isAdmin
  }

  render() {
    const { organization, currentUserId, hasTeamSwitcher } = this.props
    const members = organization.Users
    const invites = organization.Invitations
    const isAdmin = this.userIsAdmin()

    if (hasTeamSwitcher) {
      return (
        <div className="team-members-form2">
          {isAdmin ? (
            <MembersForm
              onSubmit={this.handleAdd}
              hasTeamSwitcher={hasTeamSwitcher}
            />
          ) : null}
          <div className="team-members-members">
            {members.map(member => (
              <MemberItem
                key={member.id}
                name={member.name}
                email={member.email}
                isAdmin={member.OrganizationUser.isAdmin}
                isCurrentUser={member.id === currentUserId}
                onDelete={isAdmin ? this.handleRemoveUser(member.id) : null}
                hasTeamSwitcher={hasTeamSwitcher}
              />
            ))}
            {invites.map(invite => (
              <MemberItem
                isInvite
                key={invite.id}
                email={invite.email}
                onDelete={isAdmin ? this.handleDeleteInvite(invite.id) : null}
                hasTeamSwitcher={hasTeamSwitcher}
              />
            ))}
          </div>
        </div>
      )
    } else {
      return (
        <div className="team-members-form">
          <div>
            <p className="secondary">Team Members</p>
            <div className="team-members-members">
              {members.map(member => (
                <MemberItem
                  key={member.id}
                  name={member.name}
                  email={member.email}
                  isAdmin={member.OrganizationUser.isAdmin}
                  isCurrentUser={member.id === currentUserId}
                  onDelete={isAdmin ? this.handleRemoveUser(member.id) : null}
                />
              ))}
            </div>
          </div>
          <div>
            <div className="team-members-members">
              {invites.map(invite => (
                <MemberItem
                  isInvite
                  key={invite.id}
                  email={invite.email}
                  onDelete={isAdmin ? this.handleDeleteInvite(invite.id) : null}
                />
              ))}
            </div>
          </div>
          {isAdmin ? <MembersForm onSubmit={this.handleAdd} /> : null}
        </div>
      )
    }
  }
}

export default connect(null, { createInvite, deleteInvite, removeUser })(
  Members
)
